exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip{z-index:11002!important}.groomer-edition-form{background:#779fe0;right:300px}@media screen and (max-width:720px){.groomer-edition-form{right:50%}}.groomer-edition-form .cancel-button{color:#fff;background:transparent;border:0;font-size:30px;position:absolute;top:25px;left:10px}.groomer-edition-form .activity{margin-top:10px}.groomer-edition-form .activity span:first-child{display:block;width:50%;float:left;font-weight:700}.groomer-edition-form .activity span:nth-child(2){display:block;margin-left:50%}.groomer-item{border:2px solid #4d88d6;color:#4d88d6;margin:10px 0;padding:5px;text-align:right;font-size:13px;cursor:pointer}.groomer-item.selected{background-color:#4d88d6;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/adminPanels.less
// module id = 908
// module chunks = 0